import { useState, useMemo } from 'react'
import {Search, X, Calculator, Copy, Plus, Minus} from 'lucide-react'
import toast from 'react-hot-toast'
import { copiarTexto } from '@/utils/clipboard'

interface Produto {
  nome: string
  tamanho: string
  precoBR: number
  precoEU: number
  pv: number
  categoria: string
}

interface ItemSelecionado {
  produto: Produto
  quantidade: number
}

// ═══ CATEGORIAS ═══
const CAT_1 = 'Óleos Essenciais Individuais 5ml e 15ml'
const CAT_2 = 'Aromas Naturais — Suplementos e Alimentos'
const CAT_3 = 'Óleos Essenciais e Mix Roll-On 5 e 10ml'
const CAT_4 = 'Mix de Óleos Essenciais'
const CAT_5 = 'dōTERRA Emotional Aromatherapy®'
const CAT_6 = 'Cuidados Pessoais'
const CAT_7 = 'Kits e Acessórios'

// Preços Portugal (€)
const PRECOS_PT: Record<string, number> = {
  'Basil - Manjericão': 44.00,
  'Bergamot - Bergamota': 44.00,
  'Black Pepper - Pimenta-preta': 37.67,
  'Black Spruce - Abeto-negro': 27.00,
  'Breu Branco': 48.75,
  'Cassia - Canela-cássia': 30.00,
  'Cedarwood - Cedro': 21.00,
  'Cilantro - Coentro': 43.50,
  'Citronella - Citronela': 18.50,
  'Clary Sage - Sálvia-esclareia': 61.50,
  'Clove - Cravo': 24.25,
  'Copaiba - Copaíba': 48.00,
  'Coriander - Coentro': 34.50,
  'Cypress - Cipreste': 27.00,
  'Douglas Fir - Abeto de Douglas': 33.50,
  'Erva Baleeira': 44.75,
  'Fennel (Sweet) - Erva-doce': 21.00,
  'Frankincense - Olíbano': 97.25,
  'Geranium - Gerânio': 47.75,
  'Ginger - Gengibre': 53.75,
  'Grapefruit - Toranja': 28.00,
  'Green Mandarin - Mandarina-verde': 42.00,
  'Guaiacwood': 25.50,
  'Hawaiian Sandalwood - Sândalo-havaiano': 104.80,
  'Helichrysum - Sempre-viva': 114.60,
  'Lavender - Lavanda': 29.60,
  'Lemon - Limão-siciliano': 17.25,
  'Lemon Eucalyptus - Eucalipto-limão': 18.00,
  'Lemongrass - Capim-limão': 16.50,
  'Lime - Limão': 21.50,
  'Madagascar Vanilla': 51.75,
  'Mâlama': 36.25,
  'Marjoram - Manjerona': 32.00,
  'Melaleuca - Tea Tree': 31.50,
  'Melissa': 134.20,
  'Myrrh - Mirra': 98.25,
  'Oregano - Orégano': 34.50,
  'Patchouli': 44.00,
  'Peppermint - Hortelã-pimenta': 27.60,
  'Petitgrain': 34.50,
  'Roman Chamomile - Camomila-romana': 76.50,
  'Rosemary - Alecrim': 24.75,
  'Siberian Fir - Pinheiro-siberiano': 28.50,
  'Spearmint - Hortelã-verde': 43.50,
  'Spikenard - Nardo': 84.00,
  'Tangerine - Tangerina': 25.50,
  'Thyme - Tomilho': 43.75,
  'Vetiver': 76.75,
  'Wild Orange - Laranja-selvagem': 18.00,
  'Wintergreen': 27.00,
  'Ylang Ylang': 56.00,
  'Adaptiv® Touch': 30.00,
  'dōTERRA Brave®': 33.00,
  'dōTERRA Breathe® Touch': 22.50,
  'dōTERRA Calmer®': 30.00,
  'Clarycalm®': 43.75,
  'Copaiba Touch': 34.50,
  'dōTERRA Deep Blue® Touch': 64.50,
  'dōTERRA Frankincense Touch': 75.00,
  'Helichrysum Touch': 79.70,
  'Hope™ Touch': 31.25,
  'inTune®': 50.60,
  'Lavender Touch': 24.00,
  'Melaleuca Touch': 21.00,
  'On Guard® Touch': 36.00,
  'Oregano Touch': 22.50,
  'PastTense®': 30.00,
  'Peppermint Touch': 22.50,
  'dōTERRA Rescuer®': 24.00,
  'dōTERRA Steady®': 24.00,
  'dōTERRA Stronger®': 22.50,
  'dōTERRA Tamer®': 22.50,
  'dōTERRA Thinker®': 25.50,
  'Vetiver Touch': 49.50,
  'ZenGest® Touch': 34.50,
  'Adaptiv®': 56.75,
  'dōTERRA AromaTouch®': 43.75,
  'dōTERRA Balance®': 31.50,
  'dōTERRA Breathe®': 34.50,
  'Citrus Bliss®': 27.00,
  'DDR Prime®': 45.00,
  'dōTERRA Deep Blue®': 43.20,
  'dōTERRA Serenity®': 51.00,
  'dōTERRA Elevation®': 69.70,
  'On Guard®': 54.00,
  'dōTERRA Purify®': 30.00,
  'ZenGest®': 53.00,
  'dōTERRA Cheer®': 39.00,
  'dōTERRA Cheer® Touch Roll-On': 24.00,
  'dōTERRA Console®': 57.00,
  'dōTERRA Console® Touch Roll-On': 36.00,
  'dōTERRA Forgive®': 31.50,
  'dōTERRA Forgive® Touch Roll-On': 20.25,
  'dōTERRA Motivate®': 36.00,
  'dōTERRA Motivate® Touch Roll-On': 22.50,
  'dōTERRA Passion®': 41.85,
  'dōTERRA Passion® Touch Roll-On': 37.00,
  'dōTERRA Peace®': 46.50,
  'dōTERRA Peace® Touch Roll-On': 30.00,
}

const PRODUTOS_BR: Array<{ nome: string; tamanho: string; precoBR: number; pv: number; categoria: string }> = [
  // ─── CAT_1 — Óleos Individuais 5ml ───────────────────────────────────────
  { nome: 'Basil - Manjericão', tamanho: '5ml', precoBR: 77.50, pv: 9, categoria: CAT_1 },
  { nome: 'Bergamot - Bergamota', tamanho: '5ml', precoBR: 92.50, pv: 12, categoria: CAT_1 },
  { nome: 'Black Pepper - Pimenta-preta', tamanho: '5ml', precoBR: 187.50, pv: 24, categoria: CAT_1 },
  { nome: 'Black Spruce - Abeto-negro', tamanho: '5ml', precoBR: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Breu Branco', tamanho: '5ml', precoBR: 243.75, pv: 32, categoria: CAT_1 },
  { nome: 'Cardamom - Cardamomo', tamanho: '5ml', precoBR: 203.75, pv: 29, categoria: CAT_1 },
  { nome: 'Cassia - Canela-cássia', tamanho: '5ml', precoBR: 60.00, pv: 8, categoria: CAT_1 },
  { nome: 'Cilantro - Coentro', tamanho: '5ml', precoBR: 70.00, pv: 9, categoria: CAT_1 },
  { nome: 'Clary Sage - Sálvia-esclareia', tamanho: '5ml', precoBR: 122.50, pv: 17, categoria: CAT_1 },
  { nome: 'Clove - Cravo', tamanho: '5ml', precoBR: 54.50, pv: 7, categoria: CAT_1 },
  { nome: 'Copaiba - Copaíba', tamanho: '5ml', precoBR: 120.00, pv: 16, categoria: CAT_1 },
  { nome: 'Coriander - Coentro', tamanho: '5ml', precoBR: 65.00, pv: 9, categoria: CAT_1 },
  { nome: 'Douglas Fir - Abeto de Douglas', tamanho: '5ml', precoBR: 167.50, pv: 22, categoria: CAT_1 },
  { nome: 'Erva Baleeira', tamanho: '5ml', precoBR: 223.75, pv: 31, categoria: CAT_1 },
  { nome: 'Fennel - Erva-doce', tamanho: '5ml', precoBR: 47.50, pv: 6, categoria: CAT_1 },
  { nome: 'Frankincense - Olíbano', tamanho: '5ml', precoBR: 202.50, pv: 27, categoria: CAT_1 },
  { nome: 'Geranium - Gerânio', tamanho: '5ml', precoBR: 93.75, pv: 12, categoria: CAT_1 },
  { nome: 'Ginger - Gengibre', tamanho: '5ml', precoBR: 96.25, pv: 11, categoria: CAT_1 },
  { nome: 'Grapefruit - Toranja', tamanho: '5ml', precoBR: 55.00, pv: 6, categoria: CAT_1 },
  { nome: 'Green Mandarin - Mandarina-verde', tamanho: '5ml', precoBR: 73.75, pv: 10, categoria: CAT_1 },
  { nome: 'Hawaiian Sandalwood - Sândalo-havaiano', tamanho: '5ml', precoBR: 524.00, pv: 60, categoria: CAT_1 },
  { nome: 'Helichrysum - Sempre-viva', tamanho: '5ml', precoBR: 573.00, pv: 65, categoria: CAT_1 },
  { nome: 'Juniper Berry - Zimbro', tamanho: '5ml', precoBR: 157.50, pv: 21, categoria: CAT_1 },
  { nome: 'Lavender - Lavanda', tamanho: '5ml', precoBR: 77.50, pv: 10, categoria: CAT_1 },
  { nome: 'Lemon - Limão-siciliano', tamanho: '5ml', precoBR: 36.25, pv: 4, categoria: CAT_1 },
  { nome: 'Lemongrass - Capim-limão', tamanho: '5ml', precoBR: 32.50, pv: 4, categoria: CAT_1 },
  { nome: 'Lime - Limão', tamanho: '5ml', precoBR: 43.75, pv: 5, categoria: CAT_1 },
  { nome: 'Madagascar Vanilla', tamanho: '5ml', precoBR: 258.75, pv: 34, categoria: CAT_1 },
  { nome: 'Marjoram - Manjerona', tamanho: '5ml', precoBR: 65.00, pv: 8, categoria: CAT_1 },
  { nome: 'Melissa', tamanho: '5ml', precoBR: 671.00, pv: 76, categoria: CAT_1 },
  { nome: 'Myrrh - Mirra', tamanho: '5ml', precoBR: 186.25, pv: 19, categoria: CAT_1 },
  { nome: 'On Guard', tamanho: '5ml', precoBR: 105.00, pv: 14, categoria: CAT_1 },
  { nome: 'Oregano - Orégano', tamanho: '5ml', precoBR: 75.00, pv: 10, categoria: CAT_1 },
  { nome: 'Patchouli', tamanho: '5ml', precoBR: 85.00, pv: 11, categoria: CAT_1 },
  { nome: 'Peppermint - Hortelã-pimenta', tamanho: '5ml', precoBR: 68.75, pv: 9, categoria: CAT_1 },
  { nome: 'Petitgrain', tamanho: '5ml', precoBR: 68.75, pv: 9, categoria: CAT_1 },
  { nome: 'Pink Pepper - Pimenta-rosa', tamanho: '5ml', precoBR: 172.50, pv: 20, categoria: CAT_1 },
  { nome: 'Roman Chamomile - Camomila-romana', tamanho: '5ml', precoBR: 382.50, pv: 51, categoria: CAT_1 },
  { nome: 'Rosemary - Alecrim', tamanho: '5ml', precoBR: 50.00, pv: 6, categoria: CAT_1 },
  { nome: 'Siberian Fir', tamanho: '5ml', precoBR: 52.50, pv: 7, categoria: CAT_1 },
  { nome: 'Spearmint', tamanho: '5ml', precoBR: 73.75, pv: 10, categoria: CAT_1 },
  { nome: 'Spikenard - Nardo', tamanho: '5ml', precoBR: 420.00, pv: 56, categoria: CAT_1 },
  { nome: 'Tangerine - Tangerina', tamanho: '5ml', precoBR: 52.50, pv: 7, categoria: CAT_1 },
  { nome: 'Thyme - Tomilho', tamanho: '5ml', precoBR: 92.50, pv: 11, categoria: CAT_1 },
  { nome: 'Vetiver', tamanho: '5ml', precoBR: 162.50, pv: 18, categoria: CAT_1 },
  { nome: 'Wild Orange - Laranja-selvagem', tamanho: '5ml', precoBR: 32.50, pv: 4, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '5ml', precoBR: 92.00, pv: 12, categoria: CAT_1 },
  { nome: 'Zendocrine', tamanho: '5ml', precoBR: 73.75, pv: 9, categoria: CAT_1 },
  { nome: 'ZenGest', tamanho: '5ml', precoBR: 105.00, pv: 11, categoria: CAT_1 },
  // ─── CAT_1 — Óleos Individuais 15ml ──────────────────────────────────────
  { nome: 'Basil - Manjericão', tamanho: '15ml', precoBR: 230.00, pv: 27, categoria: CAT_1 },
  { nome: 'Bergamot - Bergamota', tamanho: '15ml', precoBR: 232.50, pv: 31, categoria: CAT_1 },
  { nome: 'Cassia - Canela-cássia', tamanho: '15ml', precoBR: 150.00, pv: 20, categoria: CAT_1 },
  { nome: 'Cedarwood - Cedro', tamanho: '15ml', precoBR: 105.00, pv: 14, categoria: CAT_1 },
  { nome: 'Cilantro - Coentro', tamanho: '15ml', precoBR: 217.50, pv: 29, categoria: CAT_1 },
  { nome: 'Citronella - Citronela', tamanho: '15ml', precoBR: 92.50, pv: 12, categoria: CAT_1 },
  { nome: 'Clary Sage - Sálvia-esclareia', tamanho: '15ml', precoBR: 307.50, pv: 41, categoria: CAT_1 },
  { nome: 'Clove - Cravo', tamanho: '15ml', precoBR: 121.25, pv: 16, categoria: CAT_1 },
  { nome: 'Copaiba - Copaíba', tamanho: '15ml', precoBR: 240.00, pv: 40, categoria: CAT_1 },
  { nome: 'Coriander - Coentro', tamanho: '15ml', precoBR: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Cypress - Cipreste', tamanho: '15ml', precoBR: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Fennel (Sweet) - Erva-doce', tamanho: '15ml', precoBR: 105.00, pv: 14, categoria: CAT_1 },
  { nome: 'Frankincense - Olíbano', tamanho: '15ml', precoBR: 486.25, pv: 64, categoria: CAT_1 },
  { nome: 'Geranium - Gerânio', tamanho: '15ml', precoBR: 238.75, pv: 31, categoria: CAT_1 },
  { nome: 'Ginger - Gengibre', tamanho: '15ml', precoBR: 268.75, pv: 33, categoria: CAT_1 },
  { nome: 'Grapefruit - Toranja', tamanho: '15ml', precoBR: 140.00, pv: 17, categoria: CAT_1 },
  { nome: 'Green Mandarin - Mandarina-verde', tamanho: '15ml', precoBR: 210.00, pv: 28, categoria: CAT_1 },
  { nome: 'Guaiacwood', tamanho: '15ml', precoBR: 127.50, pv: 16, categoria: CAT_1 },
  { nome: 'Lavender - Lavanda', tamanho: '15ml', precoBR: 148.00, pv: 23, categoria: CAT_1 },
  { nome: 'Lemon - Limão-siciliano', tamanho: '15ml', precoBR: 86.25, pv: 11, categoria: CAT_1 },
  { nome: 'Lemon Eucalyptus - Eucalipto-limão', tamanho: '15ml', precoBR: 90.00, pv: 12, categoria: CAT_1 },
  { nome: 'Lemongrass - Capim-limão', tamanho: '15ml', precoBR: 82.50, pv: 11, categoria: CAT_1 },
  { nome: 'Lime - Limão', tamanho: '15ml', precoBR: 107.50, pv: 14, categoria: CAT_1 },
  { nome: 'Mâlama', tamanho: '15ml', precoBR: 181.25, pv: 23, categoria: CAT_1 },
  { nome: 'Marjoram - Manjerona', tamanho: '15ml', precoBR: 160.00, pv: 20, categoria: CAT_1 },
  { nome: 'Melaleuca - Tea Tree', tamanho: '15ml', precoBR: 157.50, pv: 21, categoria: CAT_1 },
  { nome: 'Myrrh - Mirra', tamanho: '15ml', precoBR: 491.25, pv: 51, categoria: CAT_1 },
  { nome: 'Oregano - Orégano', tamanho: '15ml', precoBR: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Patchouli', tamanho: '15ml', precoBR: 220.00, pv: 29, categoria: CAT_1 },
  { nome: 'Peppermint - Hortelã-pimenta', tamanho: '15ml', precoBR: 138.00, pv: 23, categoria: CAT_1 },
  { nome: 'Petitgrain', tamanho: '15ml', precoBR: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Rosemary - Alecrim', tamanho: '15ml', precoBR: 123.75, pv: 16, categoria: CAT_1 },
  { nome: 'Siberian Fir - Pinheiro-siberiano', tamanho: '15ml', precoBR: 142.50, pv: 19, categoria: CAT_1 },
  { nome: 'Spearmint - Hortelã-verde', tamanho: '15ml', precoBR: 217.50, pv: 29, categoria: CAT_1 },
  { nome: 'Tangerine - Tangerina', tamanho: '15ml', precoBR: 127.50, pv: 16, categoria: CAT_1 },
  { nome: 'Thyme - Tomilho', tamanho: '15ml', precoBR: 218.75, pv: 28, categoria: CAT_1 },
  { nome: 'Vetiver', tamanho: '15ml', precoBR: 383.75, pv: 41, categoria: CAT_1 },
  { nome: 'Wild Orange - Laranja-selvagem', tamanho: '15ml', precoBR: 90.00, pv: 12, categoria: CAT_1 },
  { nome: 'Wintergreen', tamanho: '15ml', precoBR: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '15ml', precoBR: 280.00, pv: 37, categoria: CAT_1 },
  // ─── CAT_2 — Suplementos e Alimentos ─────────────────────────────────────
  { nome: 'Adaptiv® Pastilhas', tamanho: '60 pastilhas', precoBR: 231.25, pv: 31, categoria: CAT_2 },
  { nome: 'dōTERRA Beauty Power™ Collagen Elixir', tamanho: '210g', precoBR: 198.00, pv: 35, categoria: CAT_2 },
  { nome: 'Copaiba Softgels', tamanho: '60 pastilhas', precoBR: 189.00, pv: 28, categoria: CAT_2 },
  { nome: 'DDR Prime® Pastilha', tamanho: '90 pastilhas', precoBR: 243.75, pv: 35, categoria: CAT_2 },
  { nome: 'dōTERRA Creatina Lifepower', tamanho: '105g', precoBR: 179.00, pv: 27, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot', tamanho: '1 litro', precoBR: 156.00, pv: 24, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot Pack com 2', tamanho: '2 litros', precoBR: 315.00, pv: 52, categoria: CAT_2 },
  { nome: 'MetaPWR™ Aroma Natural de Especiarias', tamanho: '15ml', precoBR: 223.75, pv: 27, categoria: CAT_2 },
  { nome: 'MetaPWR™ Pastilhas', tamanho: '90 pastilhas', precoBR: 236.25, pv: 28, categoria: CAT_2 },
  { nome: 'On Guard® Beadlets', tamanho: '125 pastilhas', precoBR: 116.25, pv: 15, categoria: CAT_2 },
  { nome: 'On Guard® Pastilhas', tamanho: '60 pastilhas', precoBR: 186.25, pv: 22, categoria: CAT_2 },
  { nome: 'Peppermint Beadlets', tamanho: '125 pastilhas', precoBR: 105.00, pv: 12, categoria: CAT_2 },
  { nome: 'Turmeric - Cúrcuma (Ingestão)', tamanho: '15ml', precoBR: 218.75, pv: 28, categoria: CAT_2 },
  { nome: 'Turmeric Pastilhas', tamanho: '60 pastilhas', precoBR: 186.25, pv: 24, categoria: CAT_2 },
  { nome: 'VM Complex', tamanho: '120 cápsulas', precoBR: 186.00, pv: 28, categoria: CAT_2 },
  { nome: 'Zendocrine® Pastilhas', tamanho: '60 pastilhas', precoBR: 168.00, pv: 21, categoria: CAT_2 },
  { nome: 'ZenGest® Pastilhas', tamanho: '60 pastilhas', precoBR: 161.25, pv: 20, categoria: CAT_2 },
  // ─── CAT_3 — Roll-On 5ml e 10ml ──────────────────────────────────────────
  { nome: 'Adaptiv® Touch', tamanho: '10ml', precoBR: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'dōTERRA Brave®', tamanho: '10ml', precoBR: 165.00, pv: 22, categoria: CAT_3 },
  { nome: 'dōTERRA Breathe® Touch', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Calmer®', tamanho: '10ml', precoBR: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'Clarycalm®', tamanho: '10ml', precoBR: 218.75, pv: 28, categoria: CAT_3 },
  { nome: 'Copaiba Touch', tamanho: '10ml', precoBR: 172.50, pv: 23, categoria: CAT_3 },
  { nome: 'dōTERRA Deep Blue® Touch', tamanho: '10ml', precoBR: 322.50, pv: 42, categoria: CAT_3 },
  { nome: 'dōTERRA Frankincense Touch', tamanho: '10ml', precoBR: 375.00, pv: 50, categoria: CAT_3 },
  { nome: 'Helichrysum Touch', tamanho: '10ml', precoBR: 398.50, pv: 50, categoria: CAT_3 },
  { nome: 'Hope™ Touch', tamanho: '10ml', precoBR: 156.25, pv: 20, categoria: CAT_3 },
  { nome: 'inTune®', tamanho: '10ml', precoBR: 253.00, pv: 32, categoria: CAT_3 },
  { nome: 'Jasmine Touch', tamanho: '10ml', precoBR: 295.00, pv: 39, categoria: CAT_3 },
  { nome: 'Lavender Touch', tamanho: '10ml', precoBR: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'Melaleuca Touch', tamanho: '10ml', precoBR: 105.00, pv: 14, categoria: CAT_3 },
  { nome: 'On Guard® Touch', tamanho: '10ml', precoBR: 180.00, pv: 24, categoria: CAT_3 },
  { nome: 'Oregano Touch', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'PastTense®', tamanho: '10ml', precoBR: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'Peppermint Touch', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Rescuer®', tamanho: '10ml', precoBR: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'Rose Touch', tamanho: '10ml', precoBR: 487.50, pv: 65, categoria: CAT_3 },
  { nome: 'dōTERRA Steady®', tamanho: '10ml', precoBR: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'dōTERRA Stronger®', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Tamer®', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Thinker®', tamanho: '10ml', precoBR: 127.50, pv: 17, categoria: CAT_3 },
  { nome: 'Vetiver Touch', tamanho: '10ml', precoBR: 247.50, pv: 33, categoria: CAT_3 },
  { nome: 'Whisper™ Touch', tamanho: '5ml', precoBR: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'ZenGest® Touch', tamanho: '10ml', precoBR: 172.50, pv: 23, categoria: CAT_3 },
  // ─── CAT_4 — Mix de Óleos ─────────────────────────────────────────────────
  { nome: 'Adaptiv®', tamanho: '15ml', precoBR: 283.75, pv: 37, categoria: CAT_4 },
  { nome: 'Air-X™', tamanho: '15ml', precoBR: 173.75, pv: 23, categoria: CAT_4 },
  { nome: 'dōTERRA AromaTouch®', tamanho: '15ml', precoBR: 218.75, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Balance®', tamanho: '15ml', precoBR: 157.50, pv: 21, categoria: CAT_4 },
  { nome: 'dōTERRA Breathe®', tamanho: '15ml', precoBR: 172.50, pv: 23, categoria: CAT_4 },
  { nome: 'Citrus Bliss®', tamanho: '15ml', precoBR: 135.00, pv: 17, categoria: CAT_4 },
  { nome: 'DDR Prime®', tamanho: '15ml', precoBR: 225.00, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Deep Blue®', tamanho: '5ml', precoBR: 216.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Serenity®', tamanho: '15ml', precoBR: 255.00, pv: 34, categoria: CAT_4 },
  { nome: 'dōTERRA Elevation®', tamanho: '15ml', precoBR: 348.50, pv: 42, categoria: CAT_4 },
  { nome: 'Eucalyptus (Blend)', tamanho: '15ml', precoBR: 143.75, pv: 19, categoria: CAT_4 },
  { nome: 'Forest Bathing', tamanho: '15ml', precoBR: 236.25, pv: 28, categoria: CAT_4 },
  { nome: 'dōTERRA Hygge™', tamanho: '15ml', precoBR: 262.50, pv: 33, categoria: CAT_4 },
  { nome: 'On Guard®', tamanho: '15ml', precoBR: 270.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Purify®', tamanho: '15ml', precoBR: 150.00, pv: 20, categoria: CAT_4 },
  { nome: 'Sunny Citrus', tamanho: '15ml', precoBR: 142.50, pv: 16, categoria: CAT_4 },
  { nome: 'Supermint', tamanho: '15ml', precoBR: 181.25, pv: 25, categoria: CAT_4 },
  { nome: 'TerraShield®', tamanho: '15ml', precoBR: 82.50, pv: 11, categoria: CAT_4 },
  { nome: 'Zendocrine®', tamanho: '15ml', precoBR: 185.00, pv: 24, categoria: CAT_4 },
  { nome: 'ZenGest®', tamanho: '15ml', precoBR: 265.00, pv: 35, categoria: CAT_4 },
  // ─── CAT_5 — Emotional Aromatherapy ──────────────────────────────────────
  { nome: 'dōTERRA Cheer®', tamanho: '5ml', precoBR: 195.00, pv: 26, categoria: CAT_5 },
  { nome: 'dōTERRA Cheer® Touch Roll-On', tamanho: '10ml', precoBR: 120.00, pv: 16, categoria: CAT_5 },
  { nome: 'dōTERRA Console®', tamanho: '5ml', precoBR: 285.00, pv: 38, categoria: CAT_5 },
  { nome: 'dōTERRA Console® Touch Roll-On', tamanho: '10ml', precoBR: 180.00, pv: 24, categoria: CAT_5 },
  { nome: 'Kit dōTERRA Touch Emotional Aromatherapy®', tamanho: 'Caixa', precoBR: 751.25, pv: 100, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive®', tamanho: '5ml', precoBR: 157.50, pv: 21, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive® Touch Roll-On', tamanho: '10ml', precoBR: 101.25, pv: 13, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate®', tamanho: '5ml', precoBR: 180.00, pv: 24, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate® Touch Roll-On', tamanho: '10ml', precoBR: 112.50, pv: 15, categoria: CAT_5 },
  { nome: 'dōTERRA Passion®', tamanho: '5ml', precoBR: 209.25, pv: 28, categoria: CAT_5 },
  { nome: 'dōTERRA Passion® Touch Roll-On', tamanho: '10ml', precoBR: 185.00, pv: 27, categoria: CAT_5 },
  { nome: 'dōTERRA Peace®', tamanho: '5ml', precoBR: 232.50, pv: 31, categoria: CAT_5 },
  { nome: 'dōTERRA Peace® Touch Roll-On', tamanho: '10ml', precoBR: 150.00, pv: 20, categoria: CAT_5 },
  // ─── CAT_6 — Cuidados Pessoais ────────────────────────────────────────────
  { nome: 'Breathe Balm Stick', tamanho: '13,5g', precoBR: 111.25, pv: 14, categoria: CAT_6 },
  { nome: 'Citrus Bliss Loção para as Mãos', tamanho: '75ml', precoBR: 72.50, pv: 9, categoria: CAT_6 },
  { nome: 'Conditioner Hair Care Condicionador', tamanho: '500ml', precoBR: 159.00, pv: 18, categoria: CAT_6 },
  { nome: 'Conditioner Leave-in Condicionador Leave-in', tamanho: '237ml', precoBR: 148.75, pv: 15, categoria: CAT_6 },
  { nome: 'Correct-X® Gel Reparador', tamanho: '15ml', precoBR: 105.00, pv: 12, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub', tamanho: '120ml', precoBR: 222.75, pv: 33, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub Travel Pack', tamanho: '5 bisnagas', precoBR: 60.00, pv: 5, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Stick + Copaiba', tamanho: '30g', precoBR: 139.00, pv: 23, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Esfoliante para o Corpo', tamanho: '226g', precoBR: 158.50, pv: 16, categoria: CAT_6 },
  { nome: 'Óleo de Coco Fracionado', tamanho: '115ml', precoBR: 106.25, pv: 11, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Loção para Mãos e Corpo', tamanho: '200ml', precoBR: 112.00, pv: 13, categoria: CAT_6 },
  { nome: 'HD Clear™ Roll-On', tamanho: '10ml', precoBR: 135.00, pv: 18, categoria: CAT_6 },
  { nome: 'Lavender Fields™ Body Splash', tamanho: '100ml', precoBR: 142.88, pv: 18, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Natural', tamanho: '125g', precoBR: 70.00, pv: 5, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Travel Pack', tamanho: '5 bisnagas', precoBR: 18.75, pv: 1, categoria: CAT_6 },
  { nome: 'Shampoo Protetor', tamanho: '500ml', precoBR: 145.00, pv: 18, categoria: CAT_6 },
  { nome: 'dōTERRA Pûre™ Femme Eau de Parfum', tamanho: '60ml', precoBR: 375.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Pûr™ Homme Eau de Parfum', tamanho: '60ml', precoBR: 375.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Sabonete Hidratante', tamanho: '250ml', precoBR: 98.00, pv: 10, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Manteiga Hidratante Corporal', tamanho: '198g', precoBR: 168.00, pv: 14, categoria: CAT_6 },
  { nome: 'Salubelle™', tamanho: '10ml', precoBR: 543.75, pv: 68, categoria: CAT_6 },
  { nome: 'Verage Solução de Limpeza Facial', tamanho: '60ml', precoBR: 150.00, pv: 21, categoria: CAT_6 },
  { nome: 'Verage Hidratante Facial', tamanho: '30ml', precoBR: 217.50, pv: 27, categoria: CAT_6 },
  { nome: 'Verage Tônico Facial', tamanho: '50ml', precoBR: 217.00, pv: 22, categoria: CAT_6 },
  { nome: 'Verage Collection', tamanho: '', precoBR: 674.00, pv: 67, categoria: CAT_6 },
  { nome: 'Verage® Creme Hidratante', tamanho: '48g', precoBR: 227.50, pv: 32, categoria: CAT_6 },
  { nome: 'Yarrow|Pom', tamanho: '15ml', precoBR: 352.50, pv: 47, categoria: CAT_6 },
  { nome: 'Yarrow|Pom Ativo Botânico Duo', tamanho: '30ml', precoBR: 697.50, pv: 93, categoria: CAT_6 },
  // ─── CAT_7 — Kits ─────────────────────────────────────────────────────────
  { nome: 'Kit Técnica dōTERRA AromaTouch®', tamanho: 'Caixa', precoBR: 780.00, pv: 104, categoria: CAT_7 },
  { nome: 'Kit Técnica dōTERRA AromaTouch® com Difusor', tamanho: 'Caixa', precoBR: 1225.00, pv: 115, categoria: CAT_7 },
  { nome: 'Blooming Trio Kit', tamanho: '', precoBR: 281.25, pv: 35, categoria: CAT_7 },
  { nome: 'Difusor de Parede Myst', tamanho: '', precoBR: 371.25, pv: 10, categoria: CAT_7 },
  { nome: 'dōTERRA Dawn® Umidificador Aromático', tamanho: '', precoBR: 598.00, pv: 15, categoria: CAT_7 },
  { nome: "dōTERRA Collector's Kit Box", tamanho: '', precoBR: 892.00, pv: 135, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Conforto', tamanho: '', precoBR: 285.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Equilíbrio', tamanho: '', precoBR: 298.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Inspire', tamanho: '', precoBR: 268.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Revitalize', tamanho: '', precoBR: 263.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA Brasil Living Kit', tamanho: 'Caixa', precoBR: 720.00, pv: 120, categoria: CAT_7 },
  { nome: 'dōTERRA Construa seu Legado Kit', tamanho: '', precoBR: 1200.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Culinária Essencial', tamanho: 'Caixa', precoBR: 668.75, pv: 66, categoria: CAT_7 },
  { nome: 'dōTERRA Culinária Essencial Sem Livro', tamanho: 'Caixa', precoBR: 537.50, pv: 55, categoria: CAT_7 },
  { nome: 'dōTERRA Essencial Para o Lar (Pebble)', tamanho: 'Caixa', precoBR: 1888.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Essencial Para o Lar (Petal)', tamanho: 'Caixa', precoBR: 1888.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Kids Kit', tamanho: '', precoBR: 766.25, pv: 89, categoria: CAT_7 },
  { nome: 'Kit de Apresentação', tamanho: '', precoBR: 140.00, pv: 12, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Início Rápido', tamanho: '', precoBR: 600.00, pv: 100, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Primeiros Cuidados', tamanho: '', precoBR: 1122.50, pv: 132, categoria: CAT_7 },
  { nome: 'dōTERRA Wooden Box', tamanho: '', precoBR: 79.00, pv: 0, categoria: CAT_7 },
  { nome: 'Gênesis Performance', tamanho: '', precoBR: 59.00, pv: 0, categoria: CAT_7 },
  { nome: 'Gênesis Beauty Fit', tamanho: '', precoBR: 750.00, pv: 100, categoria: CAT_7 },
  { nome: 'Kit com Difusor Pebble™', tamanho: '', precoBR: 173.75, pv: 11, categoria: CAT_7 },
  { nome: 'Livro Culinária Essencial', tamanho: '', precoBR: 112.50, pv: 10, categoria: CAT_7 },
  { nome: 'Petal 2.0 Kit', tamanho: '', precoBR: 498.75, pv: 75, categoria: CAT_7 },
]

// Monta tabela unificada
const PRODUTOS: Produto[] = PRODUTOS_BR.map(p => ({
  ...p,
  precoEU: PRECOS_PT[p.nome] ?? 0,
}))

const normalizar = (s: string) =>
  s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

const chaveProduto = (p: Produto) => `${p.nome}__${p.tamanho}`

type Pais = 'brasil' | 'portugal'

export default function CalculadoraAba() {
  const [pais, setPais] = useState<Pais>('brasil')
  const [busca, setBusca] = useState('')
  const [itens, setItens] = useState<ItemSelecionado[]>([])

  const isBR = pais === 'brasil'
  const simbolo = isBR ? 'R$' : '€'

  const formatarValor = (v: number) =>
    v.toLocaleString(isBR ? 'pt-BR' : 'pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  const precoAtual = (p: Produto) => isBR ? p.precoBR : p.precoEU

  const resultados = useMemo(() => {
    const termo = normalizar(busca.trim())
    if (!termo) return []
    return PRODUTOS.filter(p => normalizar(p.nome).includes(termo) || normalizar(p.tamanho).includes(termo)).slice(0, 30)
  }, [busca])

  const estaNoCarrinho = (p: Produto) =>
    itens.some(i => chaveProduto(i.produto) === chaveProduto(p))

  const toggleProduto = (p: Produto) => {
    setItens(prev => {
      const existe = prev.some(i => chaveProduto(i.produto) === chaveProduto(p))
      if (existe) return prev.filter(i => chaveProduto(i.produto) !== chaveProduto(p))
      return [...prev, { produto: p, quantidade: 1 }]
    })
  }

  const removerItem = (p: Produto) => {
    setItens(prev => prev.filter(i => chaveProduto(i.produto) !== chaveProduto(p)))
  }

  const alterarQuantidade = (p: Produto, delta: number) => {
    setItens(prev => prev.map(i => {
      if (chaveProduto(i.produto) !== chaveProduto(p)) return i
      const novaQtd = Math.max(1, i.quantidade + delta)
      return { ...i, quantidade: novaQtd }
    }))
  }

  const setQuantidade = (p: Produto, valor: string) => {
    const num = parseInt(valor, 10)
    if (isNaN(num)) return
    const qtd = Math.max(1, num)
    setItens(prev => prev.map(i =>
      chaveProduto(i.produto) === chaveProduto(p) ? { ...i, quantidade: qtd } : i
    ))
  }

  const totalPV = itens.reduce((acc, i) => acc + i.produto.pv * i.quantidade, 0)
  const totalProdutos = itens.reduce((acc, i) => acc + precoAtual(i.produto) * i.quantidade, 0)

  const montarOrcamentoCompleto = (): string => {
    let texto = `*Orçamento de Óleos Essenciais*\n\n`
    itens.forEach(({ produto: p, quantidade }) => {
      const tam = p.tamanho ? ` ${p.tamanho}` : ''
      const subtotal = precoAtual(p) * quantidade
      if (quantidade > 1) {
        texto += `- ${p.nome}${tam} (x${quantidade}): ${simbolo} ${formatarValor(subtotal)}\n`
      } else {
        texto += `- ${p.nome}${tam}: ${simbolo} ${formatarValor(subtotal)}\n`
      }
    })
    texto += `\n*Total: ${simbolo} ${formatarValor(totalProdutos)}*\n${totalPV} PV`
    return texto
  }

  const copiar = async (texto: string, label: string) => {
    if (itens.length === 0) {
      toast.error('Selecione pelo menos um produto')
      return
    }
    try {
      await copiarTexto(texto)
      toast.success(`${label} copiado!`)
    } catch {
      toast.error('Erro ao copiar')
    }
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Cabeçalho */}
      <div>
        <h2 className="text-2xl font-cormorant font-semibold text-texto-escuro mb-1 flex items-center gap-2">
          <Calculator className="w-6 h-6 text-verde-escuro" />
          Calculadora de Óleos
        </h2>
        <p className="text-sm text-texto-suave">Consulte os valores dos óleos essenciais dōTERRA.</p>
      </div>

      {/* Aviso informativo */}
      <div
        className="flex items-start gap-3 px-4 py-3 rounded-xl text-sm"
        style={{ backgroundColor: '#F8F4EF', border: '1px solid #EDE0D4', color: '#666666' }}
      >
        <span className="text-base flex-shrink-0">💡</span>
        <span>
          Esta calculadora é para consulta de valores dos óleos essenciais. O frete e a taxa
          de adesão não estão incluídos neste cálculo e devem ser informados separadamente
          no momento da venda.
        </span>
      </div>

      {/* Seletor de país */}
      <div className="flex gap-3">
        <button
          onClick={() => { setPais('brasil'); setItens([]) }}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
            pais === 'brasil'
              ? 'bg-[#2D6A4F] text-white shadow-md'
              : 'bg-white border-2 border-[#EDE0D4] text-[#5F5E5A] hover:border-[#2D6A4F]'
          }`}
        >
          🇧🇷 Brasil — R$
        </button>
        <button
          onClick={() => { setPais('portugal'); setItens([]) }}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all ${
            pais === 'portugal'
              ? 'bg-[#2D6A4F] text-white shadow-md'
              : 'bg-white border-2 border-[#EDE0D4] text-[#5F5E5A] hover:border-[#2D6A4F]'
          }`}
        >
          🇵🇹 Portugal — €
        </button>
      </div>

      {/* Campo de busca */}
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#B08968' }} />
        <input
          type="text"
          value={busca}
          onChange={e => setBusca(e.target.value)}
          placeholder="Digite o nome do óleo ou produto..."
          className="w-full pl-12 pr-4 py-3 rounded-xl border-2 focus:outline-none focus:border-[#52B788]"
          style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF', color: '#2C2C2A' }}
        />
      </div>

      {/* Resultados da busca */}
      {busca.trim() && (
        <div className="rounded-xl border overflow-hidden" style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}>
          {resultados.length === 0 ? (
            <div className="p-4 text-sm" style={{ color: '#5F5E5A' }}>
              Nenhum produto encontrado.
            </div>
          ) : (
            <ul className="divide-y" style={{ borderColor: '#EDE0D4' }}>
              {resultados.map(p => {
                const preco = precoAtual(p)
                const marcado = estaNoCarrinho(p)
                return (
                  <li
                    key={chaveProduto(p)}
                    onClick={() => toggleProduto(p)}
                    className="flex items-center gap-3 p-3 cursor-pointer hover:bg-[#F8F4EF] transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={marcado}
                      onChange={() => toggleProduto(p)}
                      onClick={e => e.stopPropagation()}
                      className="w-5 h-5 accent-[#2D6A4F] cursor-pointer flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium" style={{ color: '#2C2C2A' }}>
                        {p.nome}
                        {p.tamanho && (
                          <span className="ml-2 text-sm font-normal" style={{ color: '#5F5E5A' }}>
                            {p.tamanho}
                          </span>
                        )}
                      </div>
                      <div className="text-xs" style={{ color: '#B08968' }}>{p.categoria}</div>
                    </div>
                    <div className="text-right">
                      {preco > 0 ? (
                        <div className="font-semibold" style={{ color: '#2D6A4F' }}>
                          {simbolo} {formatarValor(preco)}
                        </div>
                      ) : (
                        <div className="text-xs italic" style={{ color: '#B08968' }}>Consultar</div>
                      )}
                      <div className="text-xs" style={{ color: '#5F5E5A' }}>
                        {p.pv > 0 ? `${p.pv} PV` : 'sem PV'}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}

      {/* Tabela de produtos selecionados */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <Calculator className="w-5 h-5" style={{ color: '#2D6A4F' }} />
          <h4 className="font-semibold" style={{ color: '#2D6A4F' }}>
            Produtos selecionados {itens.length > 0 && `(${itens.length})`}
          </h4>
        </div>

        {itens.length === 0 ? (
          <div
            className="p-4 rounded-xl text-sm text-center"
            style={{ backgroundColor: '#F8F4EF', color: '#5F5E5A', border: '1px dashed #EDE0D4' }}
          >
            Nenhum produto selecionado. Use a busca acima para adicionar produtos.
          </div>
        ) : (
          <div className="rounded-xl border overflow-hidden" style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}>
            {/* Cabeçalho da tabela */}
            <div
              className="hidden sm:grid text-xs font-semibold px-4 py-2"
              style={{
                gridTemplateColumns: '1fr 130px 90px 60px 90px 60px 36px',
                backgroundColor: '#F8F4EF',
                color: '#B08968',
                borderBottom: '1px solid #EDE0D4',
              }}
            >
              <span>Produto</span>
              <span className="text-center">Quantidade</span>
              <span className="text-right">Valor unit.</span>
              <span className="text-right">PV unit.</span>
              <span className="text-right">Subtotal</span>
              <span className="text-right">PV subtotal</span>
              <span></span>
            </div>

            {/* Linhas */}
            <ul className="divide-y" style={{ borderColor: '#EDE0D4' }}>
              {itens.map(({ produto: p, quantidade }) => {
                const precoUnit = precoAtual(p)
                const subtotal = precoUnit * quantidade
                const pvSubtotal = p.pv * quantidade
                return (
                  <li key={chaveProduto(p)} className="px-4 py-3">
                    {/* Layout mobile: empilhado */}
                    <div className="sm:hidden space-y-2">
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1 min-w-0">
                          <div className="font-medium text-sm" style={{ color: '#2C2C2A' }}>
                            {p.nome}
                            {p.tamanho && (
                              <span className="ml-1 font-normal" style={{ color: '#5F5E5A' }}>
                                {p.tamanho}
                              </span>
                            )}
                          </div>
                          <div className="text-xs mt-0.5" style={{ color: '#B08968' }}>{p.categoria}</div>
                        </div>
                        <button
                          onClick={() => removerItem(p)}
                          className="p-1.5 rounded-full hover:bg-red-50 transition-colors flex-shrink-0"
                          title="Remover"
                        >
                          <X className="w-4 h-4 text-red-500" />
                        </button>
                      </div>
                      <div className="flex items-center justify-between gap-4">
                        {/* Controle de quantidade mobile */}
                        <div className="flex items-center gap-1">
                          <button
                            onClick={() => alterarQuantidade(p, -1)}
                            className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#F8F4EF]"
                            style={{ borderColor: '#EDE0D4' }}
                          >
                            <Minus className="w-3 h-3" style={{ color: '#5F5E5A' }} />
                          </button>
                          <input
                            type="number"
                            min={1}
                            value={quantidade}
                            onChange={e => setQuantidade(p, e.target.value)}
                            className="w-10 text-center text-sm font-semibold border rounded-lg py-0.5 focus:outline-none focus:border-[#52B788]"
                            style={{ borderColor: '#EDE0D4', color: '#2C2C2A' }}
                          />
                          <button
                            onClick={() => alterarQuantidade(p, 1)}
                            className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#D8F3DC]"
                            style={{ borderColor: '#52B788', color: '#2D6A4F' }}
                          >
                            <Plus className="w-3 h-3" />
                          </button>
                        </div>
                        <div className="text-right text-sm">
                          <div className="font-bold" style={{ color: '#2D6A4F' }}>
                            {simbolo} {formatarValor(subtotal)}
                          </div>
                          <div className="text-xs" style={{ color: '#5F5E5A' }}>{pvSubtotal} PV</div>
                        </div>
                      </div>
                    </div>

                    {/* Layout desktop: tabela */}
                    <div
                      className="hidden sm:grid items-center gap-3"
                      style={{ gridTemplateColumns: '1fr 130px 90px 60px 90px 60px 36px' }}
                    >
                      {/* Coluna 1: Produto */}
                      <div className="min-w-0">
                        <div className="font-medium text-sm truncate" style={{ color: '#2C2C2A' }}>
                          {p.nome}
                          {p.tamanho && (
                            <span className="ml-1 font-normal text-xs" style={{ color: '#5F5E5A' }}>
                              {p.tamanho}
                            </span>
                          )}
                        </div>
                        <div className="text-xs truncate" style={{ color: '#B08968' }}>{p.categoria}</div>
                      </div>

                      {/* Coluna 2: Quantidade */}
                      <div className="flex items-center justify-center gap-1">
                        <button
                          onClick={() => alterarQuantidade(p, -1)}
                          className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#F8F4EF]"
                          style={{ borderColor: '#EDE0D4' }}
                        >
                          <Minus className="w-3 h-3" style={{ color: '#5F5E5A' }} />
                        </button>
                        <input
                          type="number"
                          min={1}
                          value={quantidade}
                          onChange={e => setQuantidade(p, e.target.value)}
                          className="w-12 text-center text-sm font-semibold border rounded-lg py-0.5 focus:outline-none focus:border-[#52B788]"
                          style={{ borderColor: '#EDE0D4', color: '#2C2C2A' }}
                        />
                        <button
                          onClick={() => alterarQuantidade(p, 1)}
                          className="w-7 h-7 rounded-full flex items-center justify-center border transition-colors hover:bg-[#D8F3DC]"
                          style={{ borderColor: '#52B788', color: '#2D6A4F' }}
                        >
                          <Plus className="w-3 h-3" />
                        </button>
                      </div>

                      {/* Coluna 3: Valor unitário */}
                      <div className="text-right text-sm font-medium" style={{ color: '#2C2C2A' }}>
                        {precoUnit > 0 ? `${simbolo} ${formatarValor(precoUnit)}` : '—'}
                      </div>

                      {/* Coluna 4: PV unitário */}
                      <div className="text-right text-sm" style={{ color: '#5F5E5A' }}>
                        {p.pv > 0 ? `${p.pv}` : '—'}
                      </div>

                      {/* Coluna 5: Subtotal */}
                      <div className="text-right text-sm font-bold" style={{ color: '#2D6A4F' }}>
                        {precoUnit > 0 ? `${simbolo} ${formatarValor(subtotal)}` : '—'}
                      </div>

                      {/* Coluna 6: PV subtotal */}
                      <div className="text-right text-sm font-semibold" style={{ color: '#52B788' }}>
                        {p.pv > 0 ? pvSubtotal : '—'}
                      </div>

                      {/* Coluna 7: Remover */}
                      <div className="flex justify-center">
                        <button
                          onClick={() => removerItem(p)}
                          className="p-1.5 rounded-full hover:bg-red-50 transition-colors"
                          title="Remover"
                        >
                          <X className="w-4 h-4 text-red-500" />
                        </button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </div>

      {/* Totais */}
      {itens.length > 0 && (
        <div
          className="rounded-xl p-5 space-y-2"
          style={{ backgroundColor: '#D8F3DC', border: '1px solid #52B788' }}
        >
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Total de PV</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>{totalPV}</span>
          </div>
          <div className="border-t pt-2 mt-1" style={{ borderColor: '#52B788' }}>
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold" style={{ color: '#2C2C2A' }}>Total dos produtos</span>
              <span className="text-xl font-bold" style={{ color: '#2D6A4F' }}>
                {simbolo} {formatarValor(totalProdutos)}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Botão de copiar */}
      <div>
        <button
          onClick={() => copiar(montarOrcamentoCompleto(), 'Orçamento completo')}
          disabled={itens.length === 0}
          className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: '#2D6A4F', color: '#FFFFFF' }}
        >
          <Copy className="w-4 h-4" />
          Copiar orçamento completo
        </button>
      </div>
    </div>
  )
}
